import { ConnectedRouter } from "react-router-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
import { Provider, connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Route, withRouter } from "react-router";
import React from "react";
import UserUtil from "./util/user";

import { history } from "./reducers/configureStore";
import Account from "./containers/Account";
import Home from "./containers/Home";
import Login from "./containers/Login";
import CorporateList from "./containers/CorporateList";
import PersistGateLoading from "./components/loading/PersistGateLoading";
import Report from "./containers/Report";
import StressIndividual from "./containers/ReportPanels/Stress/StressIndividual";
import PeopleOverview from "./containers/ReportPanels/People/PeopleOverview";
import StressUsageOverview from "./containers/ReportPanels/Stress/StressUsageOverview";
import IndividualUser from "./containers/ReportPanels/People/IndividualUser";
import StressByLevel from "./containers/ReportPanels/Stress/StressByLevel";
import StressByAge from "./containers/ReportPanels/Stress/StressByAge";
import StressByGender from "./containers/ReportPanels/Stress/StressByGender";
import StressByCategory from "./containers/ReportPanels/Stress/StressByCategory";
import StressByReturning from "./containers/ReportPanels/Stress/StressByReturning";

import CounselingOverview from "./containers/ReportPanels/Counseling/CounselingOverview";
import CounselingGender from "./containers/ReportPanels/Counseling/CounselingGender";
import CounselingProvider from "./containers/ReportPanels/Counseling/CounselingProvider";
import CounselingPlatform from "./containers/ReportPanels/Counseling/CounselingPlatform";
import CounselingTopic from "./containers/ReportPanels/Counseling/CounselingTopic";
import CounselingReturning from "./containers/ReportPanels/Counseling/CounselingReturning";
import CounselingFeedback from "./containers/ReportPanels/Counseling/CounselingVisitFeedback";
import CounselingAgeRange from "./containers/ReportPanels/Counseling/CounselingAgeRange";
import CounselingVisitOutcome from "./containers/ReportPanels/Counseling/CounselingVisitOutcome";
import CounselingCategory from "./containers/ReportPanels/Counseling/CounselingCategory";

/**
 * Dev Only page.
 */
// import Playground from "./containers/Playground";

import ROUTE, { AttrRouteFormat } from "./constants/route";
import Setting from "./containers/Setting";
import StartupAction from "./reducers/StartupReducer";
import store, { persistor } from "./reducers/";
import Token from "./util/token";
import RouteUtil from "./util/route";
import OrgUtil from "./util/organize";
require("./prototype/");

class AttrReportRoute extends React.Component {
	componentWillReceiveProps(props) {
		this.forceUpdate();
	}
	makeRoute(categoryInfo, attrFormat, comp) {
		const key = `/${RouteUtil.CreateCategoryRouteKey(categoryInfo, attrFormat)}`;
		return <PrivateRoute key={key} path={key}
			component={comp} compProp={{ categoryInfo }} />;
	}
	render() {
		const { category } = this.props;
		let routes = category.map((v) => this.makeRoute(v, AttrRouteFormat.STRESS, StressByCategory));
		// Need to change to counseling by category later.
		routes = routes.concat(category.map((v) => this.makeRoute(v, AttrRouteFormat.COUNSELING, CounselingCategory)));
		return routes;
	}
};
function state2props(state, props) {
	const orgCategorys = OrgUtil.getAllCategoryInfoFromState(state);
	return Object.assign({}, props, { category: orgCategorys });
}
const ConnectedAttrReportRoute = connect(state2props)(AttrReportRoute);

class App extends React.Component {
	render() {
		return (<Provider store={store}>
			<PersistGate loading={<PersistGateLoading />}
				persistor={persistor}
				onBeforeLift={() => store.dispatch(StartupAction.startup())}>
				<ConnectedRouter history={history}>
					<div>
						<LoginRoute exact path="/" component={Login} />
						<PrivateRoute path={`/${ROUTE.HOME}`} component={Home} />
						<PrivateRoute path={`/${ROUTE.CORPORATE_LIST}`} component={CorporateList} />
						<PrivateRoute path={`/${ROUTE.STRESS_INDIVIDUAL_QUESTION}`} component={StressIndividual} />
						<PrivateRoute path={`/${ROUTE.PEOPLE_OVERVIEW}`} component={PeopleOverview} />
						<PrivateRoute path={`/${ROUTE.STRESS_USAGE_OVERVIEW}`} component={StressUsageOverview} />
						<PrivateRoute path={`/${ROUTE.INDIVIDUAL_USER}`} component={IndividualUser} />
						<PrivateRoute path={`/${ROUTE.STRESS_BY_LEVEL}`} component={StressByLevel} />
						<PrivateRoute path={`/${ROUTE.STRESS_BY_AGE}`} component={StressByAge} />
						<PrivateRoute path={`/${ROUTE.STRESS_BY_GENDER}`} component={StressByGender} />
						<PrivateRoute path={`/${ROUTE.STRESS_BY_RETURNING}`} component={StressByReturning} />
						<PrivateRoute path={`/${ROUTE.COUNSELING_OVERVIEW}`} component={CounselingOverview} />
						<PrivateRoute path={`/${ROUTE.COUNSELING_BY_GENDER}`} component={CounselingGender} />
						<PrivateRoute path={`/${ROUTE.COUNSELING_BY_PROVIDER}`} component={CounselingProvider} />
						<PrivateRoute path={`/${ROUTE.COUNSELING_BY_PLATFORM}`} component={CounselingPlatform} />
						<PrivateRoute path={`/${ROUTE.COUNSELING_BY_TOPIC}`} component={CounselingTopic} />
						<PrivateRoute path={`/${ROUTE.COUNSELING_BY_AGE}`} component={CounselingAgeRange} />
						<PrivateRoute path={`/${ROUTE.COUNSELING_BY_USER_RETENTION}`} component={CounselingReturning} />
						<PrivateRoute path={`/${ROUTE.COUNSELING_BY_FEEDBACK}`} component={CounselingFeedback} />
						<PrivateRoute path={`/${ROUTE.COUNSELING_BY_VISIT_OUTCOME}`} component={CounselingVisitOutcome} />
						<ConnectedAttrReportRoute />
						<PrivateRoute path={`/${ROUTE.REPORT}`} component={Report} />
						<PrivateRoute path={`/${ROUTE.ACCOUNT}`} component={Account} />
						<PrivateRoute path={`/${ROUTE.SETTING}`} component={Setting} />
						{/* <PrivateRoute path={`/${ROUTE.PLAYGROUND}`} component={Playground} /> */}
					</div>
				</ConnectedRouter>
			</PersistGate>
		</Provider>
		);
	}
};

const LoginRoute = ({ component: Component, ...rest }) => {
	const { token } = store.getState().authen;
	console.log(store.getState().user);
	const { user } = store.getState().user;
	return (
		<Route {...rest} render={props => {
			if(token && Token.validateToken(token)) {
				return <Redirect to={{
					pathname: `/${ROUTE.CORPORATE_LIST}`,
					state: { from: props.location }
				}} />;
			} else
				return <Component {...props} />;
				
		}} />
	);
};


const PrivateRoute = ({ component: Component, ...rest }) => {
	const { token } = store.getState().authen;
	return (
		<Route {...rest} render={props => (
			token && Token.validateToken(token) ?
				(<Component {...rest.compProp} {...props} />)
				:
				(
					<Redirect to={{
						pathname: "/",
						state: { from: props.location }
					}} />
				)
		)} />
	);
};

const PrivateRouteForSuperadminOnly = ({ component: Component, ...rest }) => {
	const { token } = store.getState().authen;
	const { user } = store.getState().user;
	let roles = [];
	let isSuperAdmin = false;
	if(user) {
		roles = user.roles;
		isSuperAdmin = UserUtil.isRole(roles, UserUtil.Roles.SuperAdmin) ;
	}

	return (
		<Route {...rest} render={props => (
			token && Token.validateToken(token)  && isSuperAdmin ?
				(<Component {...rest.compProp} {...props} />)
				:
				(
					<Redirect to={{
						pathname: "/",
						state: { from: props.location }
					}} />
				)
		)} />
	);
};
export default App;



// WEBPACK FOOTER //
// ./src/App.js